import { action, makeAutoObservable } from 'mobx';
import type { Optional } from 'chaika-common-types';

import { MeatballButtonMenuItem } from '@components/ActionButtons/MeatballButton';
import { HeaderComponents } from '@core/Page/Header/types';

export interface HeaderParams {
    left?: Content;
    center?: Content;
    right?: Content;
    bottom?: Content;
    isHide?: boolean;
    rightContentBeforeActions?: boolean;
}

interface Content {
    component: HeaderComponents;
    props?: object;
}

export class HeaderView {
    public leftContent: Optional<Content>;
    public centerContent: Optional<Content>;
    public rightContent: Optional<Content>;
    public bottomContent: Optional<Content>;
    public actions: MeatballButtonMenuItem[] = [];
    public isHide: boolean = false;
    public rightContentBeforeActions: boolean = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    @action.bound
    public setHeaderView({
        left,
        right,
        center,
        bottom,
        isHide = false,
        rightContentBeforeActions = false,
    }: HeaderParams): void {
        this.leftContent = left;
        this.centerContent = center;
        this.rightContent = right;
        this.bottomContent = bottom;
        this.isHide = isHide;
        this.rightContentBeforeActions = rightContentBeforeActions;
    }

    @action.bound
    public reset(): void {
        this.leftContent = undefined;
        this.centerContent = undefined;
        this.rightContent = undefined;
        this.bottomContent = undefined;
        this.isHide = false;
        this.rightContentBeforeActions = false;
    }

    @action.bound
    public setActions(actions: MeatballButtonMenuItem[] = []): void {
        this.actions = actions;
    }
}
